export function mergeUnique<T>(arr1: T[], arr2: T[]): T[] {
  const combined = [...arr1, ...arr2]
  const seen = new Set()

  return combined.filter((item) => {
    const serialized = JSON.stringify(item)
    if (seen.has(serialized)) {
      return false
    }
    seen.add(serialized)
    return true
  })
}

export function chunk<T>(arr: T[], size: number): T[][] {
  return arr.reduce((acc, item, index) => {
    const chunkIndex = Math.floor(index / size)
    if (!acc[chunkIndex]) {
      acc[chunkIndex] = []
    }
    acc[chunkIndex].push(item)
    return acc
  }, [] as T[][])
}

export function shuffle<T>(arr: T[]): T[] {
  return arr.sort(() => Math.random() - 0.5)
}

export function uniqueBy<T>(arr: T[], key: keyof T): T[] {
  const seen = new Map<T[keyof T], boolean>()
  return arr.filter((item) => {
    const keyValue = item[key]
    if (seen.has(keyValue)) {
      return false
    }
    seen.set(keyValue, true)
    return true
  })
}
